import { Injectable, inject } from '@angular/core';
import { EDeliverableType } from '@enums/campaign.enum';
import { IDeliverableConfig } from '../deliverable-list.interface';
import { TextDeliverableService } from '../shared/text-deliverable/text-deliverable.service';
import { DescriptionComponent } from './description.component';

@Injectable({
  providedIn: 'root',
})
export class DescriptionService {
  private readonly textDeliverableService = inject(TextDeliverableService);

  public getConfig(): IDeliverableConfig {
    return this.textDeliverableService.getConfig({
      component: DescriptionComponent,
      defaultNameTranslationKey: 'pages.campaignForm.ctaDialog.ctaDetails.deliverables.descriptionDeliverable.title',
      deliverableType: EDeliverableType.description,
    });
  }
}
